import React from 'react'

import { usePrevious } from '../../hooks/use-previous'
import { useFinancialsTableContext } from './FinancialsTableContext'
import { TABLE_ROW_HIGHT } from './constants'

interface Props {
  categoryAreasCounts: number[]
  dataKeys: string[]
}

export function useFinancialsTablePersistScrollPosition({ categoryAreasCounts, dataKeys }: Props) {
  const { settings, scrollInfo } = useFinancialsTableContext()
  const previousSettings = usePrevious(settings)

  React.useLayoutEffect(() => {
    const widgetSettingsSectionElement = document.getElementById('js-widget-settings-section')
    if (!previousSettings || !scrollInfo || !widgetSettingsSectionElement) return

    const financialsTables = document.getElementsByClassName('js-financials-widget')
    const widgetSettingsSectionElementTopPosition = widgetSettingsSectionElement.getBoundingClientRect().top
    let index = 0
    let lastAbsDiffInPx: number | null = null

    Array.from(financialsTables).forEach((financialTableElement, i) => {
      const { top } = financialTableElement.getBoundingClientRect()
      const absDiffInPx = Math.abs(top - widgetSettingsSectionElementTopPosition)
      if (lastAbsDiffInPx === null || absDiffInPx < lastAbsDiffInPx) {
        lastAbsDiffInPx = absDiffInPx
        index = i
      }
    })

    let areas = 0
    for (let i = 0; i < index; i++) {
      areas += categoryAreasCounts[i]
    }

    let sign = 0
    dataKeys.forEach((dataKey) => {
      if (settings[dataKey] !== previousSettings[dataKey]) {
        sign = settings[dataKey] ? 1 : -1
      }
    })

    const shift = areas * TABLE_ROW_HIGHT * sign
    window.scrollTo(window.scrollX, scrollInfo.yPosition + shift)

    // effect should run only when scroll info is changed = user toggled data settings
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollInfo])
}
